import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const movimentacoes = () => {
  const auth = useAuth();

  async function list(page = 1) {
    let retorno;
    try {
        const {data} = await http.get(`/movements?page=${page}`, auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function show(id) {
    let retorno;
    try {
        const {data} = await http.get('/movements/' + id, auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  return {list, show}
}
